<template>
    <div class="sStatusMapperAction">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <form @submit.prevent="handleSubmit(send)">
                <vs-row>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <h5>{{title}}</h5>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <ValidationProvider vid="value" :name="$t('global.Value')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Value')}}</label>
                                <vs-input
                                    name="value"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Value')"
                                    v-model="params.value"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2 text-right">
                            <vs-button button="submit" ref="btn">{{ $t('buttons.Save') }}</vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import EventBus from "@/store/eventBus"

export default {
    props: ['popupData', 'popupType', 'popupButton'],


    data() {
        return {
            title: '',
            params: {
                value: '',
            }
        }
    },

    components: {
        vSelect
    },

    methods: {
        async send() {
            try {
                let path = this.$url.settings_system.update
                let method = 'POST'

                const params = {...this.params}
                params.id = this.popupData.id

                Object.keys(params).map(key => {
                    if (!params[key]) delete params[key]
                    if (typeof params[key] === 'string') params[key] = params[key].trim()
                })

                await send(path, method, {params})

                EventBus.$emit('updateSystemSettings')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
                await this.$store.dispatch('GET_USER_DATA')
            } catch (e) {
                if(e.response) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(e).send
            }
        },
    },

    async mounted() {
        this.title = this.popupData.title
        this.params.value = this.popupData.value

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
